import { useForm, SubmitHandler } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import Lottie from 'lottie-react';
import React, { useState, useEffect, useRef } from 'react';
import { AppDispatch, RootState } from '../redux/store';
import Loader from '../img/car_loading.json';
import { uploadCheckInImage } from '../redux/action';
import { useDropzone } from 'react-dropzone';
import FinalAgreement from './finalAgreement';
import ImageWithBasePath from '../../../core/data/img/ImageWithBasePath';
import Slider from 'react-slick';
 
const Checkin = ({
  booking,
  clearSignature,
  handleAccept,
  showScrollTop,
  handleScroll,
  scrollToTop,
  scrollToBottom,
  BookingAgreement,
  termsRef,
  isAccepted,
  signRef,
  loading,
  finalAgreementChecklist,
  setIsAccepted,
  setStep,
  step,
  checkinRef,
  handleSuccess,
}: {
  booking: any;
  clearSignature: any;
  handleAccept: any;
  showScrollTop: any;
  handleScroll: any;
  scrollToTop: any;
  scrollToBottom: any;
  BookingAgreement: any;
  termsRef: any;
  isAccepted: any;
  signRef: any;
  loading: boolean;
  finalAgreementChecklist: any;
  setIsAccepted: any;
  setStep: any;
  step: any;
  checkinRef: any;
  handleSuccess: any;
}) => {
  interface Attachment {
    file: File;
    name: string;
    label: string;
    type: 'selfie' | 'upload';
  }
  type FormValues = {
    attachments: any; // correct type
  };

  const dispatch = useDispatch<AppDispatch>();

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const [selfieWithCarFiles, setSelfieWithCarFiles] = useState<Attachment[]>(
    []
  );
  const [damagesFiles, setDamagesFiles] = useState<Attachment[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [Error, setError] = useState('');
  // const [isMobile] = useState(window.innerWidth <= 767);

  const [isShowReviewImage, setIsShowReviewImage] = useState(false);
  const [isShowDamageImage, setIsShowDamageImage] = useState(false);
 
 
  const {
    bookingDetail,
    user,
    checkInCarImagesLoading,
    checkInCarImagesSuccess, 
    checkInCarImages,
    progressMessages,
    bookingUploadAgreementSuccess,
  } = useSelector((state: RootState) => ({
    user: state.auth.user,
    checkInCarImagesSuccess: state.booking.checkInCarImagesSuccess,
     checkInCarImagesLoading: state.booking.checkInCarImagesLoading,
    checkInCarImages: state.booking.checkInCarImages,
    progressMessages: state.booking.progressMessages,
    bookingUploadAgreementSuccess: state.booking.bookingUploadAgreementSuccess,
    bookingDetail: state.booking.bookingDetail,
  }));

  const { handleSubmit, setValue, reset, watch } = useForm<FormValues>({
    defaultValues: {
      attachments: [],
    },
  });

  const attachments: Attachment[] = watch('attachments') || [];

  // const onDropLicense = (acceptedFiles: File[]) => {
  //   const newAttachments: Attachment[] = acceptedFiles.map((file, index) => {
  //     const extension = file.name.split('.').pop();

  //     const fileName = `${user?.first_name}_license_selfie_with_car_upload_${user?.id}_${booking?.id}_${selfieWithCarFiles.length + index + 1}.${extension}`;

  //     const renamedFile = new File([file], fileName, {
  //       type: file.type,
  //       lastModified: file.lastModified,
  //     });

  //     return {
  //       file: renamedFile,
  //       name: renamedFile.name,
  //       label: 'license_selfie_with_car',
  //       type: 'upload',
  //     };
  //   });

  //   setSelfieWithCarFiles((prevFiles) => [...prevFiles, ...newAttachments]);
  //   setValue('attachments', [...attachments, ...newAttachments]);
  // };

  // const {
  //   getRootProps: getLicenseRootProps,
  //   getInputProps: getLicenseInputProps,
  // } = useDropzone({
  //   onDrop: onDropLicense,
  //   accept: { 'image/*': ['.png', '.jpg', '.jpeg'] },
  //   multiple: true,
  // });


  const downloadFile = async (fileUrl: string, name: string) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Get original file extension
      const urlParts = fileUrl.split('?')[0].split('/');
      const originalFileName = urlParts[urlParts.length - 1];
      const extensionMatch = originalFileName.match(/\.[^/.]+$/);
      const extension = extensionMatch ? extensionMatch[0] : '';

      const fileName = `${name}${extension}`;
      downloadBlob(blob, fileName);
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  };

  const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const onDropDamages = (acceptedFiles: File[]) => {
    const customerUploadedCount =
      checkInCarImages?.['customerUploaded']?.length || 0;
    const existingCount = damagesFiles.length + customerUploadedCount;
    const remainingSlots = Math.max(0, 5 - existingCount);

    const filesToAdd = acceptedFiles.slice(0, remainingSlots);

    if (filesToAdd.length > 0) {
      const newAttachments: Attachment[] = filesToAdd.map((file, index) => {
        const extension = file.name.split('.').pop();
        const fileName = `${user?.first_name}_damages_upload_${user?.id}_${booking?.id}_${damagesFiles.length + index + 1}.${extension}`;

        const renamedFile = new File([file], fileName, {
          type: file.type,
          lastModified: file.lastModified,
        });

        return {
          file: renamedFile,
          name: renamedFile.name,
          label: 'customer_checkin_image',
          type: 'upload',
        };
      });

      setDamagesFiles((prevFiles) => [...prevFiles, ...newAttachments]);
      setValue('attachments', [...attachments, ...newAttachments]);
    }
  };

  const {
    getRootProps: getDamagesRootProps,
    getInputProps: getDamagesInputProps,
  } = useDropzone({
    onDrop: onDropDamages,
    accept: { 'image/*': ['.png', '.jpg', '.jpeg'] },
    multiple: true,
    maxFiles: 5,
  });

  const [nav, setNav] = useState(null);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: nav || undefined,
    ref: (slider: any) => (sliderRef.current = slider),
  };

  useEffect(() => { 
    setNav(sliderRef.current);
  }, []);
 

  const handleSelfieCapture = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const newAttachments: Attachment[] = Array.from(files).map((file) => ({
        file: file,
        name: file.name,
        label: 'license_selfie_with_car',
        type: 'upload',
      }));

      setSelfieWithCarFiles((prevFiles) => [...prevFiles, ...newAttachments]);
      setValue('attachments', [...attachments, ...newAttachments]);
    }
  };

  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const handleOrientationChange = () => {
      const orientation = window.screen.orientation?.type || window.orientation;

      if (orientation === 'landscape-primary') {
        setRotation(0); // normal
      } else if (orientation === 'landscape-secondary') {
        setRotation(180); // upside down
      } else if (orientation === 'portrait-secondary') {
        setRotation(180); // upside down
      } else {
        // portrait-primary
        setRotation(0); // normal
      }
    };

    window.addEventListener('orientationchange', handleOrientationChange);
    handleOrientationChange(); // Initial run

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  const captureSelfie = () => {
    if (videoRef.current && canvasRef.current && !Error) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');

      if (context) {
        // Set canvas size to match video size
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Now draw with correct resolution
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas?.toBlob((blob) => {
          if (blob) {
            const selfieIndex = selfieWithCarFiles.length + 1;
            const fileName = `${user?.first_name}_license_selfie_with_car_selfie_${user?.id}_${booking?.id}_${selfieIndex}.png`;

            const selfieFile = new File([blob], fileName, {
              type: 'image/png',
            });

            const newAttachment: Attachment = {
              file: selfieFile,
              name: selfieFile.name,
              label: 'license_selfie_with_car',
              type: 'upload',
            };

            setSelfieWithCarFiles((prevFiles) => [...prevFiles, newAttachment]);

            setValue('attachments', [...attachments, newAttachment], {
              shouldValidate: true,
            });
          }
        }, 'image/png');

        const stream = videoRef.current.srcObject as MediaStream;
        const tracks = stream?.getTracks();
        tracks?.forEach((track) => track.stop());
        setIsCameraOpen(false);
      }
    }
  };

  const removeFile = (fileName: string, type: 'damages' | 'selfie') => {
    const selfieWithCarListFiles = selfieWithCarFiles ?? [];
    const damageListFiles = damagesFiles ?? [];

    let updatedSelfieWithCarFiles = selfieWithCarListFiles;
    let updatedDamageListFiles = damageListFiles;

    if (type === 'selfie') {
      updatedSelfieWithCarFiles = selfieWithCarListFiles.filter(
        (file) => file.name !== fileName
      );
      setSelfieWithCarFiles(updatedSelfieWithCarFiles);
    } else {
      updatedDamageListFiles = damageListFiles.filter(
        (file) => file.name !== fileName
      );
      setDamagesFiles(updatedDamageListFiles);
    }

    const updatedAttachments = [
      ...updatedDamageListFiles,
      ...updatedSelfieWithCarFiles,
    ];

    setValue('attachments', updatedAttachments);
  };

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    const formData = new FormData();

    formData.append(
      'upload_type',
      booking?.bookingattachments?.find(
        (item: any) => item.type === 'license_selfie_with_car'
      )
        ? 'reupload'
        : 'initial'
    );
    formData.append('booking_id', booking?.id);

    formData.append('checkin_image_approved', confirmCheckin ? '1' : '0');

    if (data?.attachments && Array.isArray(data.attachments)) {
      data.attachments.forEach((attachment, index) => {
        formData.append(`attachments[${index}][file]`, attachment?.file);
        formData.append(`attachments[${index}][label]`, attachment?.label);
        formData.append(`attachments[${index}][type]`, attachment?.type);
      });
    }

    dispatch(uploadCheckInImage(formData));
  };

  useEffect(() => {
    reset();
    setSelfieWithCarFiles([]);
    setDamagesFiles([]);
     setIsShowDamageImage(false);
  setIsShowReviewImage(false);

    // setConfirmCheckin(
    //   bookingDetail?.final_agreement_review_enabled === 1 ? true : false
    // );
  }, [bookingDetail]);

  const closeModal = () => {
    const modalElement = document.getElementById('checkin');
    const backdrop = document.querySelector('.modal-backdrop');

    if (modalElement && modalElement.style.display !== 'none') {
      modalElement.style.display = 'none';
      modalElement.classList.remove('show', 'modal-open');
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    if (backdrop) {
      backdrop.remove();
    }
  };

  useEffect(() => {
    if (checkInCarImagesSuccess) { 
      if (confirmCheckin) {
        setStep(1);
         setConfirmCheckin(false);
          reset();
      } else{
         closeModal();
      }    
      setSelfieWithCarFiles([]);
    } else if (bookingUploadAgreementSuccess) {
      closeModal();
    }
  }, [checkInCarImagesSuccess, bookingUploadAgreementSuccess]);

  const openCamera = async () => {
    setIsCameraOpen(true);
    try {
      setError('');
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          facingMode: 'user',
        },
      });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      setError(
        'Permission denied when accessing the camera. Please enable camera access in device settings.'
      );
      console.error('Error accessing camera:', error);
    }
  };

  const [confirmCheckin, setConfirmCheckin] = useState(false);

  const uploadedImages = [
    ...(checkInCarImages?.['customerUploaded'] ?? []),
    ...(checkInCarImages?.['adminUploaded'] ?? []),
  ];

  

 
  return (
    <>
      <div
        className="modal fade  check-availability-modal"
        id="checkin"
        data-bs-keyboard="false"
        data-bs-backdrop="static"
        ref={checkinRef}
      >
        <div className="modal-dialog modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center">
                  <h4 className="modal-title">Checkin</h4>

                  <span
                    className="align-center text-black fs-xx-large"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    aria-hidden="true"
                    onClick={() => {
                      setStep(0);
                      handleSuccess();
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    ×
                  </span>
                </div>
              </div>

              {step === 1 ? (
                <>
                  <div className="sign-group">
                    <div
                      onClick={() => {
                        setStep(0);
                      }}
                      className="border-0 text-primary-dark d-flex align-items-center pb-2"
                    >
                      <i className="bx bx-arrow-back fs-5 me-2"></i>

                      <span className="mt-1"> Back </span>
                    </div>
                  </div>

                  <FinalAgreement
                    clearSignature={clearSignature}
                    handleAccept={handleAccept}
                    showScrollTop={showScrollTop}
                    handleScroll={handleScroll}
                    scrollToTop={scrollToTop}
                    scrollToBottom={scrollToBottom}
                    BookingAgreement={BookingAgreement}
                    isAccepted={isAccepted}
                    termsRef={termsRef}
                    signRef={signRef}
                    loading={loading}
                    finalAgreementChecklist={finalAgreementChecklist}
                  />
                </>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="col-12">
                    <div
                      onClick={() => {
                        if (
                          booking?.license_selfie_with_car_status ===
                            'pending' ||
                          booking?.license_selfie_with_car_status === 'rejected'
                        ) {
                          openCamera();
                        }
                      }}
                      style={{
                        border: !['pending', 'rejected'].includes(
                          booking?.license_selfie_with_car_status
                        )
                          ? '2px dashed #737373'
                          : '2px dashed #ccc',

                        opacity: !['pending', 'rejected'].includes(
                          booking?.license_selfie_with_car_status
                        )
                          ? 0.6
                          : 1,
                        padding: '8px',
                        cursor: 'pointer',
                        marginBottom: '10px',
                        textAlign: 'center',
                      }}
                    >
                      <p className="mb-0">
                        {'Click to take Selfie(s) with your License'}
                      </p>
                    </div>
                    {/* <div
                      {...getLicenseRootProps()}
                      style={{
                        border: !['pending', 'rejected'].includes(
                          booking?.license_selfie_with_car_status
                        )
                          ? '2px dashed #737373'
                          : '2px dashed #ccc',

                        opacity: !['pending', 'rejected'].includes(
                          booking?.license_status
                        )
                          ? 0.6
                          : 1,
                        padding: '8px',
                        cursor: 'pointer',
                        marginBottom: '10px',
                        textAlign: 'center',
                      }}
                    >
                      <input
                        {...getLicenseInputProps()}
                        disabled={
                          !['pending', 'rejected'].includes(
                            booking?.license_selfie_with_car_status
                          )
                        }
                      />
                      <p className="mb-0">
                        {isMobile
                          ? 'Click to upload your selfie with car files'
                          : 'Drag & drop your selfie with car files here, or Click to Select'}
                      </p>
                    </div> */}

                    <div className="text-center mb-2">
                      {isCameraOpen && (
                        <div>
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            style={{
                              width: '100%',
                              maxWidth: '300px',
                              marginTop: '10px',
                              transformOrigin: 'center center',
                              transform: `rotate(${rotation}deg) scaleX(-1)`, // mirror for selfie camera
                            }}
                          />
                          <canvas ref={canvasRef} style={{ display: 'none' }} />

                          <p className="text-danger">{Error}</p>
                          <button
                            type="button"
                            className="mt-2 p-2 border-0"
                            onClick={captureSelfie}
                            style={{ cursor: 'pointer' }}
                          >
                            📸 Capture Selfie
                          </button>
                        </div>
                      )}
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        capture="user"
                        onChange={handleSelfieCapture}
                        style={{ display: 'none' }}
                      />
                    </div>

                    <p className="text-wrap mt-1">
                      {progressMessages['check_in'] &&
                        progressMessages['check_in']['selfie_with_car'][
                          booking.license_selfie_with_car_status
                        ]}
                    </p>

                    {selfieWithCarFiles?.length > 0 &&
                      (selfieWithCarFiles.length > 1 ? (
                        <Slider {...settings} className="checkin-slider mb-1">
                          {selfieWithCarFiles.map((item: any, index: any) => (
                            <div
                              key={index}
                              className="d-grid objectFit product-img fit-image-container"
                            >
                              <div>
                                {item.name}{' '}
                                <span
                                  style={{ color: 'red', cursor: 'pointer' }}
                                  onClick={() =>
                                    removeFile(item.name, 'selfie')
                                  }
                                >
                                  <i className="feather icon-x-circle" />
                                </span>
                              </div>
                              <ImageWithBasePath
                                src={URL.createObjectURL(item.file)}
                                alt={`Car Image ${index + 1}`}
                                width={'100%'}
                                height={'100%'}
                              />
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        selfieWithCarFiles.map((item: any, index: any) => (
                          <div
                            key={index}
                            className="d-grid  objectFit product-img fit-image-container"
                          >
                            <div>
                              {item.name}{' '}
                              <span
                                style={{ color: 'red', cursor: 'pointer' }}
                                onClick={() => removeFile(item.name, 'selfie')}
                              >
                                <i className="feather icon-x-circle" />
                              </span>
                            </div>

                            <ImageWithBasePath
                              src={URL.createObjectURL(item.file)}
                              alt={`Car Image ${index + 1}`}
                              width={'100%'}
                              height={'100%'}
                            />
                          </div>
                        ))
                      ))}
                  </div>

                  {/* {checkInCarImages?.['adminUploaded']?.length > 0 && (
                    <div>
                      <h6
                        className="align-items-center mb-1"
                        style={{ color: '#111' }}
                      >
                        Review car images{' '}
                        {[
                          ...(checkInCarImages?.['customerUploaded'] ?? []),
                          ...(checkInCarImages?.['adminUploaded'] ?? []),
                        ]?.length > 0 && (
                          <i
                            className="fa fa-eye text-primary ms-1"
                            onClick={() => {
                              setIsShowReviewImage(!isShowReviewImage);
                            }}
                          />
                        )}
                      </h6>

                      {isShowReviewImage &&
                        [
                          ...(checkInCarImages?.['customerUploaded'] ?? []),
                          ...(checkInCarImages?.['adminUploaded'] ?? []),
                        ]?.length > 0 && (
                          <Slider {...settings} className="checkin-slider">
                            {[
                              ...(checkInCarImages?.['customerUploaded'] ?? []),
                              ...(checkInCarImages?.['adminUploaded'] ?? []),
                            ]?.map((item: any, index: any) => (
                              <>
                                <div
                                  key={index}
                                  className="objectFit product-img fit-image-container"
                                >
                                  <ImageWithBasePath
                                    src={item.file_url}
                                    alt={`Car Image ${index + 1}`}
                                    width={'100%'}
                                    height={'100%'}
                                  />
                                </div>
                                {item.name}{' '}
                              </>
                            ))}
                          </Slider>
                        )}

                      <h6
                        className="align-items-center my-1"
                        style={{ color: '#111' }}
                      >
                        Add photos if you notice any damage
                        {damagesFiles?.length > 0 && (
                          <i
                            className="fa fa-eye text-primary ms-1"
                            onClick={() => {
                              setIsShowDamageImage(!isShowDamageImage);
                            }}
                          />
                        )}
                      </h6>

                      <div
                        {...getDamagesRootProps()}
                        style={{
                          border:
                            checkInCarImages?.['customerUploaded']?.length > 4
                              ? '2px dashed #737373'
                              : '2px dashed #ccc',
                          opacity:
                            checkInCarImages?.['customerUploaded']?.length < 4
                              ? 1
                              : 0.6,

                          padding: '8px',
                          cursor: 'pointer',
                          marginBottom: '10px',
                          textAlign: 'center',
                        }}
                      >
                        <input
                          {...getDamagesInputProps()}
                          disabled={
                            checkInCarImages?.['customerUploaded']?.length > 4
                          }
                        />
                        <p className="mb-0">
                          {' '}
                          {
                            'Click to upload your photos if you notice any damage'
                          }{' '}
                        </p>
                      </div>

                      {isShowDamageImage &&
                        damagesFiles?.length > 0 &&
                        (damagesFiles.length > 1 ? (
                          <Slider {...settings} className="checkin-slider">
                            {damagesFiles.map((item: any, index: any) => (
                              <div
                                key={index}
                                className="d-grid objectFit product-img fit-image-container"
                              >
                                <ImageWithBasePath
                                  src={URL.createObjectURL(item.file)}
                                  alt={`Car Image ${index + 1}`}
                                  width={'100%'}
                                  height={'100%'}
                                />
                                <div>
                                  {item.name}{' '}
                                  <span
                                    style={{ color: 'red', cursor: 'pointer' }}
                                    onClick={() =>
                                      removeFile(item.name, 'damages')
                                    }
                                  >
                                    <i className="feather icon-x-circle" />
                                  </span>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          damagesFiles.map((item: any, index: any) => (
                            <div key={index} className="objectFit">
                              <ImageWithBasePath
                                src={URL.createObjectURL(item.file)}
                                alt={`Car Image ${index + 1}`}
                                width={'100%'}
                                height={'100%'}
                              />
                              <div>
                                {item.name}{' '}
                                <span
                                  style={{ color: 'red', cursor: 'pointer' }}
                                  onClick={() =>
                                    removeFile(item.name, 'damages')
                                  }
                                >
                                  <i className="feather icon-x-circle" />
                                </span>
                              </div>
                            </div>
                          ))
                        ))}
                    </div>
                  )} */}

                  {checkInCarImages?.['adminUploaded']?.length > 0 && (
                    <div>
                      {/* Review Car Images Toggle */}
                      <h6
                        className="align-items-center mb-2"
                        style={{ color: '#111', cursor: 'pointer' }}
                      >
                        Review car images{' '}
                        {uploadedImages.length > 0 && (
                          <i
                            className="fa fa-eye text-primary ms-1"
                            onClick={() =>
                              setIsShowReviewImage(!isShowReviewImage)
                            }
                          />
                        )}
                      </h6>

                      {/* Review Slider */}
                      {isShowReviewImage &&
                        uploadedImages.length > 0 &&
                        (uploadedImages.length > 1 ? (
                          <Slider {...settings} className="checkin-slider mb-1">
                            {uploadedImages.map((item: any, index: number) => (
                              <div key={index} className="objectFit  ">
                                <ImageWithBasePath
                                  src={item.file_url}
                                  alt={`Car Image ${index + 1}`}
                                  width={'100%'}
                                  height={'100%'}
                                />
                                <div className="text-center">{item.name}</div>
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          uploadedImages.map((item: any, index: number) => (
                            <div key={index} className="d-grid  objectFit mb-2">
                              <div>{item.name} </div>
                              <ImageWithBasePath
                                src={item.file_url}
                                alt={`Car Image ${index + 1}`}
                                width={'100%'}
                                height={'100%'}
                              />
                            </div>
                          ))
                        ))}

                      {/* Upload Damage Images */}
                      <h6 className="mb-2" style={{ color: '#111' }}>
                        Add photos if you notice any damage
                        {damagesFiles?.length > 0 && (
                          <i
                            className="fa fa-eye text-primary ms-1"
                            onClick={() =>
                              setIsShowDamageImage(!isShowDamageImage)
                            }
                          />
                        )}
                      </h6>

                      <div
                        {...getDamagesRootProps()}
                        style={{
                          border:
                            damagesFiles.length >= 5
                              ? '2px dashed #737373'
                              : '2px dashed #ccc',
                          opacity: damagesFiles.length >= 5 ? 0.6 : 1,
                          padding: '12px',
                          textAlign: 'center',
                          borderRadius: 8,
                          background: '#fafafa',
                          cursor: 'pointer',
                          marginBottom: 12,
                        }}
                      >
                        <input
                          {...getDamagesInputProps()}
                          disabled={damagesFiles.length >= 5}
                        />
                        <p className="mb-1">
                          Click to upload your photos if you notice any damage
                        </p>
                        <small
                          style={{
                            color: '#737373',
                          }}
                        >
                          You can upload up to {5 - damagesFiles.length} images
                        </small>
                      </div>

                      {/* Damage Image Preview */}
                      {isShowDamageImage &&
                        damagesFiles.length > 0 &&
                        (damagesFiles.length > 1 ? (
                          <Slider {...settings} className="checkin-slider mb-1">
                            {damagesFiles.map((item: any, index: number) => (
                              <div
                                key={index}
                                className="d-grid  product-img  fit-image-containers"
                              >
                                <div>
                                  {item.name}{' '}
                                  <span
                                    style={{
                                      color: 'red',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      removeFile(item.name, 'damages')
                                    }
                                  >
                                    <i className="feather icon-x-circle" />
                                  </span>
                                </div>

                                <ImageWithBasePath
                                  src={URL.createObjectURL(item.file)}
                                  alt={`Car Image ${index + 1}`}
                                  width={'100%'}
                                  height={'100%'}
                                  className="fit-images"
                                />
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          damagesFiles.map((item: any, index: number) => (
                            <div key={index} className="d-grid  objectFit mb-2">
                              <div>
                                {item.name}{' '}
                                <span
                                  style={{ color: 'red', cursor: 'pointer' }}
                                  onClick={() =>
                                    removeFile(item.name, 'damages')
                                  }
                                >
                                  <i className="feather icon-x-circle" />
                                </span>
                              </div>
                              <ImageWithBasePath
                                src={URL.createObjectURL(item.file)}
                                alt={`Car Image ${index + 1}`}
                                width={'100%'}
                                height={'100%'}
                              />
                            </div>
                          ))
                        ))}

                      {/* Proceed Button */}
                    </div>
                  )}

                  <div className="col-12 px-2 text-end">
                    {checkInCarImagesLoading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Lottie
                          animationData={Loader}
                          loop={true}
                          style={{ width: 100, height: 100 }}
                        />
                      </div>
                    ) : bookingDetail?.final_agreement_review_enabled === 0 &&
                      checkInCarImages?.['adminUploaded']?.length > 0 ? (
                      <>
                        <div className="form-check text-start mt-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="confirmCheckin"
                            checked={confirmCheckin}
                            onChange={(e) =>
                              setConfirmCheckin(e.target.checked)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="confirmCheckin"
                          >
                            I confirm that the check-in images — including any
                            I’ve uploaded — are sufficient to represent the
                            vehicle’s condition.
                          </label>
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={!confirmCheckin}
                        >
                          Proceed to Final Agreement
                        </button>
                      </>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary text-end mt-1 mb-1 "
                      >
                        {' '}
                        Upload{' '}
                      </button>
                    )}
                  </div>

                  <p className="text-wrap mt-1">
                    {progressMessages['check_in'] &&
                      progressMessages['check_in']['final_agreement']?.[
                        bookingDetail?.final_agreement_status
                      ]}
                  </p>

                  {bookingDetail?.final_agreement_review_enabled === 1 &&
                    (bookingDetail?.final_agreement_status === 'pending' ||
                      bookingDetail?.final_agreement_status === 'rejected') && (
                      <>
                        <p className="mt-1">
                          Final agreement & sign{' '}
                          <i
                            onClick={() => {
                              setStep(1);
                              clearSignature();
                              setIsAccepted(false);
                            }}
                            className={`ms-1 fa fa-file-signature text-primary`}
                            style={{ fontSize: '12px' }}
                          />{' '}
                        </p>

                        {bookingDetail.final_agreement_status ===
                          'rejected' && (
                          <>
                            {bookingDetail?.bookingattachments?.find(
                              (item: any) => item.label === 'final_agreement'
                            )?.reject_reason && (
                              <p className="text-danger text-wrap mt-1">
                                (
                                {
                                  bookingDetail?.bookingattachments?.find(
                                    (item: any) =>
                                      item.label === 'final_agreement'
                                  )?.reject_reason
                                }
                                )
                              </p>
                            )}
                          </>
                        )}
                      </>
                    )}

                  {/* {confirmCheckin &&
                    <div className="col-12 px-2 text-end">
                      {checkInCarImagesLoading ? (
                        <div className="d-flex justify-content-center align-items-center">
                          <Lottie
                            animationData={Loader}
                            loop={true}
                            style={{ width: 100, height: 100 }}
                          />
                        </div>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary me-1 mt-1"
                        >
                          {' '}
                          Upload{' '}
                        </button>
                      )}
                    </div>
                  } */}

                  {booking?.final_agreement_status === 'approved' && (
                    <>
                      {' '}
                      <h6
                        className="align-items-center mb-1"
                        style={{ color: '#111' }}
                      >
                        Review contract{' '}
                      </h6>
                      <a
                        className="btn btn-primary text-white text-center border-1"
                          onClick={() => {
                    downloadFile(
                      booking.bookingattachments?.find(
                        (item: any) => item.label === 'final_agreement'
                      )?.file_url,
                      'final_agreement'
                    );
                  }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="fas fa-download me-1"
                          style={{ cursor: 'pointer' }}
                        />
                        Final Agreement
                      </a>{' '}
                    </>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Modal */}
    </>
  );
};

export default Checkin;
